import request from "../../Requests/requests";
import { activateTimer } from "../../store/RunTimeTaskResults/RunTimeResults";

export const timerPush = (payload) => {
    return async dispatch => {
        try {
            const response = await request.put('/Timer', {taskId: payload.taskId, 
                userId: localStorage.getItem('userID'),
                timerTime: payload.startTime,
                timerIsActive: payload.timerIsActive})
            const data = response.data
            .then(() => dispatch(activateTimer({isTimerActive: payload.timerIsActive, taskId: payload.taskId, startTime: payload.startTime})))
            return data
        } catch (error) {
            return error
        }
    }
}